import { useGlobalContext } from "@root/context";
import type { Dispatch } from "react";
import { AdditionalFilters } from "./additionalFilters";
import { FilterAuthor } from "./author";
import { FilterCoachingStep } from "./coachingStep";
import { FilterPrescriber } from "./prescriber";
import { FilterSearchBar } from "./searchBar";
import { FilterStatus } from "./status";
import { FilterTeam } from "./team";
import type { IAddParticipantFilters, TAddParticipantFiltersAction } from "./types";

interface IFilterSectionProps {
  filters: IAddParticipantFilters;
  dispatch: Dispatch<TAddParticipantFiltersAction>;
}

export const FilterSection = ({ filters, dispatch }: IFilterSectionProps) => {
  const { user } = useGlobalContext();
  return (
    <AdditionalFilters values={filters} dispatch={dispatch}>
      <FilterSearchBar value={filters.search} dispatch={dispatch} />
      <FilterStatus value={filters.status} dispatch={dispatch} />
      <FilterCoachingStep value={filters.coachingSteps} dispatch={dispatch} />
      <FilterPrescriber value={filters.prescribers} dispatch={dispatch} />
      <FilterAuthor value={filters.authors} dispatch={dispatch} />
      {user.organisation.features.team.active && <FilterTeam value={filters.teams} dispatch={dispatch} />}
    </AdditionalFilters>
  );
};
